import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-720b9d01")

_pushScopeId("data-v-720b9d01")
const _hoisted_1 = { class: "flex inline-block" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("发布")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("同步到CMS")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("查看CMS")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消发布")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_card_set_assembly_view = _resolveComponent("card-set-assembly-view")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_table, { data: _ctx.cardSetAssemblies }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          width: "80",
          label: "名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "description",
          width: "180",
          label: "说明"
        }),
        _createVNode(_component_el_table_column, { label: "标签" }, {
          default: _withId(({row}) => [
            _createVNode("div", _hoisted_1, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.tags, (tag) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: tag.id
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(tag.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withId(({row}) => [
            _createVNode("div", _hoisted_2, [
              (!row.published)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "margin-right-10",
                    type: "primary",
                    size: "mini",
                    onClick: ($event: any) => (_ctx.publish(row, !row.published))
                  }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (row.published && !row.cmsId)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    class: "margin-right-10",
                    type: "primary",
                    size: "mini",
                    onClick: ($event: any) => (_ctx.syncToCMS(row))
                  }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (row.cmsId)
                ? (_openBlock(), _createBlock("a", {
                    key: 2,
                    target: "_blank",
                    class: "margin-right-10",
                    href: `https://cms.guanxintec.com/admin/content/card_set/${row.cmsId}`
                  }, [
                    _createVNode(_component_el_button, null, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ], 8, ["href"]))
                : _createCommentVNode("", true),
              (row.published)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    class: "margin-right-10",
                    type: "primary",
                    size: "mini",
                    onClick: ($event: any) => (_ctx.publish(row, !row.published))
                  }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                class: "margin-right-10",
                type: "warning",
                size: "mini",
                onClick: ($event: any) => (_ctx.view(row))
              }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_popconfirm, {
                onConfirm: ($event: any) => (_ctx.deleteAssembly(row.id)),
                title: "确定删除吗？"
              }, {
                reference: _withId(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "danger"
                  }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_drawer, {
      title: "查看",
      direction: "ltr",
      modelValue: _ctx.viewDialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewDialogVisible = $event)),
      size: "60%"
    }, {
      default: _withId(() => [
        _createVNode(_component_card_set_assembly_view, {
          saveable: true,
          "card-set-assembly-id": _ctx.currentAssemblyId
        }, null, 8, ["card-set-assembly-id"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})